import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrWrapperService } from 'src/app/services/toastr-wrapper.service';

@Component({
  selector: 'app-skip-dialog',
  templateUrl: './skip-dialog.component.html',
  styleUrls: ['./skip-dialog.component.css']
})
export class SkipDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SkipDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    private toasterService: ToastrWrapperService) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onStopClick(): void {
    this.toasterService.showError('We were unable to confirm your identity.  You may try again or complete your screening at the entry point screening station.');
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
